const analyticsRoutes = [
    {
        path: "/active-keys",
        name: "activekeys",
        component: () => import("@/views/Pages/Analytics/ActiveKeys.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/compliance-report",
        name: "compliancereport",
        component: () => import("@/views/Pages/Analytics/ComplianceReport.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reported-websites",
        name: "reportedwebsites",
        component: () => import("@/views/Pages/Analytics/ReportedWebsites.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/log-history",
        name: "loghistory",
        component: () => import("@/views/Pages/Analytics/LogHistory.vue"),
        meta: {
            requiresAuth: true,
        },
    },
     {
        path: "/audit-logs",
        name: "auditLogs",
        component: () => import("@/views/Pages/Analytics/AuditLogs.vue"),
        meta: {
            requiresAuth: true,
        },
    },
]

export default analyticsRoutes